import TranslationText from '@Components/Utilities/TranslationText';
import translator from '../Utilities/Translator';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';

/**
 * Pagination Component
 * Use this for pagination controls for all our pages to keep everything standardized and uniform.
 * @param {any} props
 * [REQUIRED] currentPage = number
 * [REQUIRED] totalPages = number
 * [REQUIRED] onChange = function(pageNumber: number)
 */

const Paging = (props) => {
    const windowSize = useWindowSize();

    const previousText = () => { return <TranslationText tKey='sandhills.prev' /> };
    const nextText = () => { return <TranslationText tKey='sandhills.next' /> };

    const getItemAriaLabel = (type, page, selected) => {
        let ariaLabel;

        switch (type) {
            case 'page':
                ariaLabel = `${(selected ? translator.translate('sandhills.tradepubwebsite.mvc.page') : translator.translate('sandhills.gotopage'))} ${page}`;
                break;
            case 'first':
                ariaLabel = translator.translate('sandhills.firstpage')
                break;
            case 'last':
                ariaLabel = translator.translate('sandhills.lastpage')
                break;
            case 'next':
                ariaLabel = translator.translate('sandhills.tradepubwebsite.mvc.nextpage')
                break;
            case 'previous':
                ariaLabel = translator.translate('sandhills.previouspage')
                break;
        };

        return ariaLabel;
    }

    return (
        <div className='paging-container'>
            <Pagination
                count={props.totalPages}
                defaultPage={props.currentPage ? props.currentPage : 1}
                page={props.currentPage ? props.currentPage : 1}
                siblingCount={2}
                boundaryCount={0}
                showFirstButton
                getItemAriaLabel={(type, page, selected) => getItemAriaLabel(type, page, selected)}
                showLastButton
                shape='rounded'
                size={windowSize.isMobile ? 'small' : 'medium'}
                onChange={(e, value) => props.onChange(value)}
                renderItem={(item) => (
                    <PaginationItem
                        components={{ previous: previousText, next: nextText }}
                        {...item}
                    />
                )}
            />
        </div>
    );
};

export default Paging;